import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import de from "shared/common/translations/de.json";
import en from "shared/common/translations/en.json";
import fr from "shared/common/translations/fr.json";
import it from "shared/common/translations/it.json";

const resources = {
  en,
  de,
  fr,
  it,
};

export const availableLanguages = Object.keys(resources);

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: false,
    supportedLngs: ["de", "en", "fr", "it"],
    nonExplicitSupportedLngs: true,
    fallbackLng: "en",
    resources,
  });

export default i18n;
